import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchCampaign,
  deleteCampaign,
  duplicateCampaign,
  updateCampaign,
  updateCampaignFilters,
  updateCampaignAutoStop,
  publishCampaign,
  editCampaign,
  fetchTemplates,
  fetchSMSTemplates,
  fetchRVMTemplates,
  fetchRookeryStatusInfo
} from "../actions/index";
import { Link } from "react-router-dom";
import StepsList from "./StepsList";
import CampaignsVersionSelect from "./CampaignsVersionSelect";
import CampaignsPublishBtn from "./CampaignsPublishBtn";
import CampaignsEditBtn from "./CampaignsEditBtn";
import CampaignsTitle from "./CampaignsTitle";
import CampaignAutoStop from "./CampaignAutoStop";
import CampaignsMeta from "./CampaignsMeta";
import CampaignsFilters from "./CampaignsFilters";
import CampaignTourSteps from "./tours/CampaignTourSteps";
import StarterCampaignTourSteps from "./tours/StarterCampaignTourSteps";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import { toastr } from "react-redux-toastr";
import scrollToComponent from "react-scroll-to-component";
import * as Constants from '../constants';

export class CampaignsShow extends Component {
  static propTypes = {
    fetchCampaign: PropTypes.func.isRequired,
    deleteCampaign: PropTypes.func.isRequired,
    updateCampaign: PropTypes.func.isRequired,
    publishCampaign: PropTypes.func.isRequired,
    fetchTemplates: PropTypes.func.isRequired,
    fetchSMSTemplates: PropTypes.func.isRequired,
    fetchRVMTemplates: PropTypes.func.isRequired,
    campaign: PropTypes.object,
    templates: PropTypes.object,
    smsTemplates: PropTypes.object,
    rvmTemplates: PropTypes.object,
    fetchRookeryStatusInfo: PropTypes.func.isRequired,
    duplicateCampaign: PropTypes.func.isRequired,
    updateCampaignFilters: PropTypes.func.isRequired,
    updateCampaignAutoStop: PropTypes.func.isRequired,
    editCampaign: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      scrollToBottom: false,
      steps: [],
      pauseSteps: [],
      startTour: false,
      startTourForPause: false,
      version_id: this.props.match.params.version_id,
      joyrideType: "continuous",
      joyrideShowSkipButton: true,
      joyrideShowStepsProgress: true
    };
  }

  componentDidMount() {
    this.fetchData();
    this.checkIfRookeryEnabled();
  }

  componentDidUpdate() {
    this.handleScrollToBottom();
  }

  handleScrollToBottom() {
    if (this.state.scrollToBottom) {
      scrollToComponent(this.stepsEnd, { offset: 1000 });
      this.setState({ scrollToBottom: false });
    }
  }

  fetchData() {
    this.props.fetchCampaign(
      this.props.match.params.id
    );
    this.props.fetchTemplates(
      "?per_page=1000"
    );
    this.props.fetchSMSTemplates(
      "?per_page=1000"
    );
    this.props.fetchRVMTemplates(
      "?per_page=1000"
    );
  }

  checkIfRookeryEnabled() {
    this.props
      .fetchRookeryStatusInfo()
      .then(response => {
        if (response.payload.data.data.rookery_enabled) {
          this.setState({ rookeryEnabled: true });
        } else {
          this.setState({ rookeryEnabled: false });
        }
      });
  }

  handleFetch() {
    this.fetchData();
  }

  onDeleteClickConfirmation() {
    const msg =
      "Are you sure you want to delete this campaign? You cannot undo deletion. Any leads will be unsubscribed.";
    const toastrConfirmOptions = {
      onOk: () => this.onDeleteClick()
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  onDeleteClick() {
    this.props
      .deleteCampaign(this.props.match.params.id)
      .then(response => {
        if (response.payload !== undefined) {
          if (this.props.campaign.data.type == "StarterCampaign") {
            this.props.history.push(`/admin/starter_campaigns?${Constants.DEFAULT_PAGINATION}`);
            toastr.success("Starter Workflow deleted!");
          } else {
            this.props.history.push(`/campaigns?${Constants.DEFAULT_PAGINATION}`);
            toastr.success("Workflow deleted!");
          }
        }
      });
  }

  onDuplicateClick() {
    this.props
      .duplicateCampaign(
        this.props.match.params.id,
        {}
      )
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Workflow duplicated!");
          this.props.history.push(`/campaigns?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  handleSave(campaignId, prms) {
    this.setState({ scrollToBottom: prms.scrollToBottom });
    if (prms.steps) {
      let newSteps = prms.steps.map((step, i) => {
        //really just the last step is new if we are told to scrollTobottom
        if (i == prms.steps.length - 1 && prms.scrollToBottom == true) {
          step.isNew = true;
        }
        delete step.email_event_stats;
        return step;
      });
      prms.steps = newSteps;
    }
    this.props
      .updateCampaign(campaignId, {
        campaign: prms
      })
      .then(() => {
        this.fetchData();
      });
  }

  handleSaveFilters(campaignId, prms) {
    this.props.updateCampaignFilters(
      campaignId,
      { campaign: prms }
    ).then(response => {
      this.fetchData();
    });
  }

  handleSaveAutoStop(campaignId, prms) {
    this.props
      .updateCampaignAutoStop(campaignId, {
        campaign: prms
      })
      .then(response => {
        if (response.payload !== undefined) {
          this.fetchData();
        }
      });
  }

  handlePublish(campaignId, updateSubscriptions) {
    this.props
      .publishCampaign(campaignId, {
        update_subscriptions: updateSubscriptions
      })
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Workflow published!");
          this.fetchData();
        }
      });
  }

  handleEdit(campaignId) {
    this.props
      .fetchCampaign(this.props.match.params.id)
      .then(() => {
        const draftVersion = this.findExistingDraftVersions();
        if (draftVersion) {
          // A draft version exists, change to that one
          this.setState({ version_id: draftVersion.id });
          this.props.history.push(`/campaigns/${this.props.match.params.id}/versions/${draftVersion.id}`);
          this.fetchData();
        } else {
          this.props
            .editCampaign(campaignId, {
              version_id: this.props.match.params.version_id
            })
            .then(campaign => {
              const versions = campaign.payload.data.data.versions.sort(
                (a, b) => b.id - a.id
              );
              this.setState({ version_id: versions[0].id });
              this.props.history.push(`/campaigns/${this.props.match.params.id}/versions/${versions[0].id}`);
              this.fetchData();
            });
        }
      });
  }

  findExistingDraftVersions() {
    // Get the last draft and use that if it exists
    const existingVersions = this.props.campaign.data.versions;
    let draftVersions = [];
    for (const version in existingVersions) {
      if (existingVersions[version].uniqueness_enrichment_field == "draft") {
        draftVersions.push(existingVersions[version]);
      }
    }
    return draftVersions.pop();
  }

  handleVersionSelect(campaignId, versionId) {
    this.setState({ version_id: versionId });
    this.props.history.push(`/campaigns/${campaignId}/versions/${versionId}`);
  }

  showPublishOrEdit(version) {
    if (version.status != "Active" && version.status != "Retired") {
      if (version.steps === undefined || version.steps.length > 0) {
        return (
          <CampaignsPublishBtn
            campaign={this.props.campaign.data}
            handlePublish={this.handlePublish.bind(this)}
          />
        );
      } else {
        return <div />;
      }
    } else {
      return (
        <CampaignsEditBtn
          campaign={this.props.campaign.data}
          handleEdit={this.handleEdit.bind(this)}
        />
      );
    }
  }

  showVersionMsg(campaign, version) {
    if (version.status == "Retired") {
      return (
        <div className="alert alert-info text-center">
          This is a retired version of your campaign. To make changes, click
          &#39;Edit&#39; to create a new version.
        </div>
      );
    } else if (campaign.status == "Active" && version.status == "Active") {
      return (
        <div className="alert alert-success text-center">
          This is the current live version. To make changes, click &#39;Edit&#39; to
          create a new version.
        </div>
      );
    } else if (campaign.status == "Active" && version.status != "Active") {
      return (
        <div className="alert alert-warning text-center">
          Your workflow is active, but this draft version has not been
          published. Once you are done making changes, click &#39;Publish&#39; to make
          this version active.
        </div>
      );
    }
  }

  startTour() {
    let joyrideSteps = [];
    if (this.props.campaign.data.type == "Campaign") {
      joyrideSteps = CampaignTourSteps.tourSteps();
    } else if (this.props.campaign.data.type == "StarterCampaign") {
      joyrideSteps = StarterCampaignTourSteps.tourSteps();
    }
    this.setState({
      steps: joyrideSteps,
      startTour: true
    });
  }

  tourCallback(data) {
    const { type } = data;
    if (type == "tour:end") {
      this.setState({ startTour: false });
    }
  }

  tooltipTourCallback(data) {
    const { type } = data;
    if (type == "tour:end") {
      this.setState({ startTourForPause: false });
    }
  }

  tooltipForPause(selector) {
    return [
      {
        content:
          'When the "Pause" checkbox is checked, the subscription for a lead to this workflow will pause until this task is completed in Lead Manager. Once marked as complete (or deleted), the campaign will continue on to the next step.',
        target: selector,
        placement: "bottom",
        disableBeacon: true
      }
    ];
  }

  handleTooltipForPause(id, e) {
    e.preventDefault();
    let selector = "#step_form_" + id + " .pause_checkbox";
    this.setState({
      pauseSteps: this.tooltipForPause(selector),
      startTourForPause: true
    });
  }

  showCampaignFilters() {
    if (this.props.campaign.data.type != "StarterCampaign") {
      return (
        <CampaignsFilters
          handleSaveFilters={this.handleSaveFilters.bind(this)}
          campaign={this.props.campaign.data}
        />
      );
    }
  }

  showBackButton() {
    if (this.props.campaign.data.type == "StarterCampaign") {
      return (
        <Link
          to={`/admin/starter_campaigns?${Constants.DEFAULT_PAGINATION}`}
          className="btn btn-default pull-left m-r-10 campaigns_back"
        >
          Back
        </Link>
      );
    } else {
      return (
        <Link
          to={`/campaigns?${Constants.DEFAULT_PAGINATION}`}
          className="btn btn-default pull-left m-r-10 campaigns_back"
        >
          Back
        </Link>
      );
    }
  }

  showDuplicateButton() {
    if (this.props.campaign.data.type == "Campaign") {
      return (
        <button
          className="btn btn-primary pull-left m-r-10 duplicate_campaign_btn"
          onClick={this.onDuplicateClick.bind(this)}
        >
          Duplicate
        </button>
      );
    }
  }

  showCampaignMeta() {
    if (this.props.campaign.data.type == "StarterCampaign") {
      return (
        <div>
          <CampaignsMeta
            campaign={this.props.campaign.data}
            handleSave={this.handleSave.bind(this)}
          />
        </div>
      );
    }
  }

  render() {
    const { campaign, templates, smsTemplates, rvmTemplates } = this.props;
    // Check to make sure we have our data
    let query = new URLSearchParams(location.search);
    if (
      !templates ||
      !smsTemplates ||
      !rvmTemplates ||
      !campaign ||
      campaign.data.id != this.props.match.params.id
    ) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    // Go to latest version if not supplied
    if (!this.props.match.params.version_id) {
      let version_ids = campaign.data.versions.map(version => {
        return version.id;
      });
      let latest_version_id = Math.max(...version_ids);
      let from_starter_workflow =
        query.from_starter_workflow == "true"
          ? "?from_starter_workflow=true"
          : "";
      this.props.history.replace(`/campaigns/${this.props.match.params.id}/versions/${latest_version_id}${from_starter_workflow}`);
      return <div />;
    }
    let version = {};
    if (campaign.data.versions.length > 0) {
      version =
        campaign.data.versions.find(
          v => v.id == this.props.match.params.version_id
        ) || {};
    }
    return (
      <div>
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <Joyride
          run={this.state.startTourForPause}
          continuous={false}
          steps={this.state.pauseSteps}
          showSkipButton={false}
          showProgress={false}
          scrollToSteps={false}
          callback={this.tooltipTourCallback.bind(this)}
        />
        <div>
          <CampaignsTitle
            campaign={campaign.data}
            handleSave={this.handleSave.bind(this)}
            handleHelp={this.startTour.bind(this)}
          />
          <CampaignAutoStop
            campaign={campaign.data}
            handleSaveAutoStop={this.handleSaveAutoStop.bind(this)}
          />
        </div>
        {this.showCampaignMeta()}
        {this.showCampaignFilters()}
        {this.showVersionMsg(campaign.data, version)}

        {this.showPublishOrEdit(version)}
        {this.showBackButton()}
        {this.showDuplicateButton()}
        <button
          className="btn btn-danger pull-left delete_campaign_btn"
          onClick={this.onDeleteClickConfirmation.bind(this)}
        >
          Delete
        </button>
        <CampaignsVersionSelect
          handle={this.handleVersionSelect.bind(this)}
          campaign={campaign.data}
          currentVersionId={this.state.version_id}
        />

        <StepsList
          key={version.updated_at}
          handleSave={this.handleSave.bind(this)}
          handleFetch={this.handleFetch.bind(this)}
          handleTooltipForPause={this.handleTooltipForPause.bind(this)}
          campaign={campaign.data}
          version={version}
          steps={version.steps}
          templates={templates.data}
          smsTemplates={smsTemplates.data}
          rvmTemplates={rvmTemplates.data}
          match={this.props.match}
          query={query}
          rookeryEnabled={this.state.rookeryEnabled}
        />

        {this.showPublishOrEdit(version)}
        {this.showBackButton()}
        {this.showDuplicateButton()}
        <button
          className="btn btn-danger pull-left delete_campaign_btn"
          onClick={this.onDeleteClickConfirmation.bind(this)}
        >
          Delete
        </button>
        <CampaignsVersionSelect
          ref={section => {
            this.stepsEnd = section;
          }}
          handle={this.handleVersionSelect.bind(this)}
          campaign={campaign.data}
          currentVersionId={this.state.version_id}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    campaign: state.campaigns.campaign,
    templates: state.templates.all,
    smsTemplates: state.smsTemplates.all,
    rvmTemplates: state.rvmTemplates.all
  };
}

export default connect(
  mapStateToProps,
  {
    fetchCampaign,
    deleteCampaign,
    duplicateCampaign,
    updateCampaign,
    updateCampaignFilters,
    updateCampaignAutoStop,
    publishCampaign,
    fetchTemplates,
    fetchSMSTemplates,
    fetchRVMTemplates,
    editCampaign,
    fetchRookeryStatusInfo
  }
)(CampaignsShow);
